import { render } from "./roadTransport.vue?vue&type=template&id=1dc85b94&scoped=true"
import script from "./roadTransport.vue?vue&type=script&lang=js"
export * from "./roadTransport.vue?vue&type=script&lang=js"

import "./roadTransport.vue?vue&type=style&index=0&id=1dc85b94&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc85b94"]])

export default __exports__